<template>
  <div>
    <a-card class="mcdm m-height-full m-display-flex flex-column">
      <div slot="title">
        <div class="m-display-flex space-between">
          <div>
            <span>Cooperative Deduction Manifest</span>
          </div>
          <a-popover slot="extra" trigger="click" placement="bottomRight">
            <span slot="title">Select Action</span>
            <ul class="m-list-wrapper bordered" slot="content">
              <li v-if="getAuth.username == dataSource.header.create_by">
                <a-button-group>
                  <a-button
                    :disabled="dataSource.header.status=='1'"
                    type="dashed"
                    icon="edit"
                    @click="handleEdit"
                    >Edit</a-button
                  >
                  <a-button
                    @click="handleDelete"
                    :disabled="dataSource.header.status=='1'"
                    type="danger"
                    icon="close-square"
                    :loading="loading.delete"
                    >Delete</a-button
                  >
                </a-button-group>
              </li>
            </ul>
            <a-button icon="more" :loading="loading.delete">Action</a-button>
          </a-popover>
        </div>
      </div>
      <template slot="extra">
      </template>
      <a-spin
        :spinning="loading.page"
        tip="Preparing To Show Data ...  "
      >
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>Period</span>
                <span class="m-list-desc">{{ moment(dataSource.header.periode,'YYYY-MM').format('MMMM YYYY') }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Description</span>
                <span class="m-list-desc">{{ dataSource.header.description }}</span>
              </li>
            </ul>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>Status</span>
                <span class="m-list-desc">
                  <a-tag v-if="dataSource.header.status_label=='Open'" color="green">{{ 
                    dataSource.header.status_label?dataSource.header.status_label.toUpperCase():'' }}</a-tag>
                  <a-tag v-else color="red">{{ dataSource.header.status_label?dataSource.header.status_label.toUpperCase():'' }}</a-tag>
                </span>
              </li>
              <li>
                <span class="m-list-title" for>Date | TLC</span>
                <span class="m-list-desc">{{ moment(dataSource.header.tgl_buat).format('DD-MM-YYYY') }} | {{ dataSource.header.create_by }}</span>
              </li>
            </ul>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <li>
              <span class="m-list-title" for>File Excel</span>
              <span class="m-list-desc">
                <a-button type="link" style="padding:0px" @click="downloadFile">{{dataSource.header.lampiran}}</a-button>
              </span>
            </li>
          </a-col>
        </a-row>
        <a-table
          class="ccd margin-top"
          :columns="columns"
          :rowKey="(record, index) => {return index;}"
          :dataSource="dataSource.data"
          :pagination="false"
          size="small"
          :scroll="{ x: 750, y: 400 }"
          bordered
          :rowClassName="(record) => {return Number(record.jumlah)==Number(record.jumlah_sebelum)?
            'r_same' : 'r_not_same'}"
        >
          <template slot="title">
            <a-row :gutter="16" type="flex" justify="space-between" align="middle">
              <a-col>
                <div class="ant-card-head-title" ><b>Deduction Detail</b></div>
              </a-col>
              <a-col>
                <a-input-search
                  v-model="search"
                  placeholder="Search Deduction Detail .. "
                />  
              </a-col>
            </a-row>
          </template>
          <template slot="no" slot-scope="text, data, index">
            {{ index + 1 }}
          </template>
          <template slot="simpanan_pokok" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.pokok"
            />
          </template>
          <template slot="simpanan_wajib" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.wajib"
            />
          </template>
          <template slot="biaya_pendaftaran" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.daftar"
            />
          </template>
          <template slot="jumlah_potongan" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.pinjaman"
            />
          </template>
          <template slot="deskripsi" slot-scope="item">
            {{ item.keterangan }}
          </template>
          <template slot="footer">
            <a-row :gutter="16" type="flex" justify="space-between" align="top">
              <a-col>
                <div><b><small>Color Desc:</small></b></div>
                <div style="display:flex;vertical-align: middle;margin-top:5px"><div class="r_same" style="width:20px;height: 100%;">&nbsp;</div><small>&nbsp;The installment/deduction amount is the same as the previous month's period</small></div>
                <div style="display:flex;vertical-align: middle;margin-top:5px"><div class="r_not_same" style="width:20px;height: 100%;">&nbsp;</div><small>&nbsp;Have a different installment/deduction amount than the previous period</small></div>
              </a-col>
              <a-col style="text-align: right;">
                <a-statistic title="Total Deduction Value (IDR)" :value="total_deduction" />
              </a-col>
            </a-row>
          </template>
        </a-table>
      </a-spin>
    </a-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "cooperative-deduction-create",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  props: ["id"],
  data(){
    return {
      loading: {
        page: false,
        delete: false
      },
      dataSource: {
        header: [],
        data: [],
        dataOriginal: []
      },
      search: "",
      total_deduction: 0,
    }
  },
  mounted(){
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
    ]),
    columns(){
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: "60px",
          align: "right",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          width: "100px",
          align: "center",
        },
        {
          title: "Principal Saving",
          key: "simpanan_pokok",
          width: "170px",
          scopedSlots: { customRender: "simpanan_pokok" },
        },
        {
          title: "Mandatory Saving",
          key: "simpanan_wajib",
          width: "170px",
          scopedSlots: { customRender: "simpanan_wajib" },
        },
        {
          title: "Registration Fee",
          key: "biaya_pendaftaran",
          width: "170px",
          scopedSlots: { customRender: "biaya_pendaftaran" },
        },
        {
          title: "Levy Amount",
          key: "jumlah_potongan",
          width: "170px",
          scopedSlots: { customRender: "jumlah_potongan" },
        },
        {
          title: "Description",
          key: "deskripsi",
          scopedSlots: { customRender: "deskripsi" },
        },
      ]
        return kolom
    }
  },
  methods:{
    moment,
    fetchData(){
      this.loading.page = true
      this.asyncAxiosGet("potongan_koperasi",
        this.getAuth,
        { id_potongan: this.id}
      )
      .then((response) => {
        this.dataSource.header = response.header
        this.dataSource.data = response.dtl
        this.dataSource.dataOriginal = this.dataSource.data

        this.total_deduction = Number(response.header.total)
        
        this.loading.page = false
      })
      .catch((err) => {
        console.log(err);
      });
    },
    downloadFile(){
      window.open(this.$serviceUrl + this.dataSource.header.lampiran_path);
    },
    handleEdit(){
      this.$router.push({
        name: "cooperativeDeductionEdit",
        params: { id: this.id },
      });
    },
    handleDelete(){
      const that = this;
      let title = "";
      title = "Are you sure to delete this data?";
      that.$confirm({
        title: title,
        content: "Yes / No?",
        okText: "Yes",
        cancelText: "No",
        onOk() {

          that.loading.delete = true
          that.asyncAxiosDelete(
            "potongan_koperasi",
            "application/json",
            that.getAuth,
            {
              id_potongan: that.id
            }
          )
          .then(() => {
            that.displayMessage("success-delete")
            that.$router.push({ name: "CooperativeList" });
          })
          .catch(() => {
            that.loading.delete = false
          });
        },
        onCancel() {},
      })
    }
  },
  watch:{
    "search"(val){
      if(val){ 
        this.dataSource.data = this.dataSource.dataOriginal.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
      }else{
        this.dataSource.data = this.dataSource.dataOriginal
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ccd:deep{
  .ant-table-body{
    thead {
      th {
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="less">
  .mcdm{
    .ant-card-head-title{
      margin-right:0px
    }
  }

  .r_same { 
    background-color: fade(@color-secondary, 35%)!important;
  }

  .r_not_same { 
    background-color: fade(@color-primary, 35%)!important;
  }
</style>